export class IncludeFile {
    static splitToWords(str, block) {
        let out = [];
        let c;
        let ofs = -1;
        let word;
        let n = str.length;
        for (let i = 0; i < n; i++) {
            c = str.charAt(i);
            if (" \t=+-*/&%!<>()'\",;".indexOf(c) >= 0) {
                if (ofs >= 0 && (i - ofs) > 1) {
                    word = str.substring(ofs, i);
                    out.push(word);
                }
                if (c == '"' || c == "'") {
                    let ofs2 = str.indexOf(c, i + 1);
                    if (ofs2 < 0) {
                        throw new Error("Sharder err:" + str);
                    }
                    out.push(str.substring(i + 1, ofs2));
                    i = ofs2;
                    ofs = -1;
                    continue;
                }
                if (c == '(' && block && out.length > 0) {
                    word = out[out.length - 1] + ";";
                    if ("vec4;main;".indexOf(word) < 0)
                        block.useFuns += word;
                }
                ofs = -1;
                continue;
            }
            if (ofs < 0)
                ofs = i;
        }
        if (ofs < n && (n - ofs) > 1) {
            word = str.substring(ofs, n);
            out.push(word);
        }
        return out;
    }
    constructor(txt) {
        this.codes = {};
        this.funs = {};
        this.curUseID = -1;
        this.funnames = "";
        this.script = txt;
        let begin = 0, ofs, end;
        while (true) {
            begin = txt.indexOf("#begin", begin);
            if (begin < 0)
                break;
            end = begin + 5;
            while (true) {
                end = txt.indexOf("#end", end);
                if (end < 0)
                    break;
                if (txt.charAt(end + 4) === 'i')
                    end += 5;
                else
                    break;
            }
            if (end < 0) {
                throw new Error("add include err,no #end:" + txt);
            }
            ofs = txt.indexOf('\n', begin);
            let words = IncludeFile.splitToWords(txt.substring(begin, ofs), null);
            if (words[1] == 'code') {
                this.codes[words[2]] = txt.substring(ofs + 1, end);
            }
            else if (words[1] == 'function') {
                ofs = txt.indexOf("function", begin);
                ofs += "function".length;
                this.funs[words[3]] = txt.substring(ofs + 1, end);
                this.funnames += words[3] + ";";
            }
            begin = end + 1;
        }
    }
    getWith(name = null) {
        let r = name ? this.codes[name] : this.script;
        if (!r) {
            throw new Error("get with error:" + name);
        }
        return r;
    }
    getFunsScript(funsdef) {
        let r = "";
        for (let i in this.funs) {
            if (funsdef.indexOf(i + ";") >= 0) {
                r += this.funs[i];
            }
        }
        return r;
    }
}
